// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgUnderReview: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M11 12V6a1 1 0 1 1 2 0v4.84l5.124 2.927a1 1 0 1 1-.992 1.737z"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M1.575 6.056A12.002 12.002 0 0 1 6.06 1.574h.001l.989 1.735a10.003 10.003 0 0 0-3.74 3.737zm20.077 3.318c.47 1.73.468 3.555-.009 5.284v.002l1.925.53v-.001a11.99 11.99 0 0 0 .01-6.34zm-4.692-6.06a10.003 10.003 0 0 1 3.735 3.74l1.736-.987a11.994 11.994 0 0 0-4.48-4.488zM10.864.054a12 12 0 0 1 4.365.388l.001.001-.537 1.923h-.002a10.003 10.003 0 0 0-5.284-.027L8.889.41a12 12 0 0 1 1.975-.356M.063 13.226a12 12 0 0 1 .356-4.37l1.927.524a10.003 10.003 0 0 0 .013 5.286l-1.925.532a11.997 11.997 0 0 1-.371-1.972m6.995 7.47a10.003 10.003 0 0 1-3.741-3.732l-1.734.991a11.993 11.993 0 0 0 4.49 4.478zm7.59.95a9.999 9.999 0 0 1-5.285.003l-.526 1.926a11.996 11.996 0 0 0 6.34-.003zm6.04-4.69a10.004 10.004 0 0 1-3.74 3.737l.989 1.736a11.999 11.999 0 0 0 4.486-4.482z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgUnderReview);
export default Memo;
